import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { theme } from '../../../../common/styles/theme';

export const ExercisesProgress: React.FC<{
	total?: number;
	done?: number;
	// opens the Exercises tab; without it the pill is just a label
	onOpen?: () => void;
}> = ({ total, done = 0, onOpen }) => {
	if (!total) return null;
	const isDone = done >= total;
	return (
		<Tooltip
			title={`${done} of ${total} exercises done${onOpen ? ' — open them' : ''}`}
			placement={'top'}
			enterDelay={500}
			disableInteractive
		>
			<Box
				component={onOpen ? 'button' : 'div'}
				onClick={onOpen ? (e: React.MouseEvent) => {
					// not the tile's own click (opens the recording)
					e.stopPropagation();
					onOpen();
				} : undefined}
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: .5,
					flexShrink: 0,
					px: 1,
					border: 'none',
					borderRadius: 999,
					fontFamily: 'inherit',
					lineHeight: '20px',
					fontWeight: 500,
					fontSize: 12,
					fontVariantNumeric: 'tabular-nums',
					background: 'none',
					color: isDone ? (theme.palette.primary as any)[500] : theme.palette.grey[500],
					...(onOpen ? {
						cursor: 'pointer',
						'&:hover': { background: isDone ? theme.palette.primary[200] : theme.palette.grey[200] },
					} : {}),
				}}
			>
				{isDone &&
					<svg width={12} height={12} viewBox={'0 0 24 24'} fill={'none'} stroke={'currentColor'} strokeWidth={3} strokeLinecap={'round'} strokeLinejoin={'round'}>
						<path d={'M20 6 9 17l-5-5'} />
					</svg>
				}
				{`Tasks ${done}/${total}`}
			</Box>
		</Tooltip>
	);
};
